function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { createEnum, generateId, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  required: 'Required'
});
var bool$1 = PT.bool,
  func$1 = PT.func,
  object$1 = PT.object,
  oneOf$1 = PT.oneOf,
  string$1 = PT.string;
var Sizes = createEnum(["small", "default", "large", "xlarge"]);
var RadioButton = /*#__PURE__*/function (_PureComponent) {
  function RadioButton() {
    var _this;
    _classCallCheck(this, RadioButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RadioButton, [].concat(args));
    _defineProperty(_this, "state", {
      // We need a unique id to link label to input and explanation
      // We keep this in state to ensure doesn't regenerate with each render
      id: _this.props.id || generateId()
    });
    return _this;
  }
  _inherits(RadioButton, _PureComponent);
  return _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checked = _this$props.checked,
        className = _this$props.className,
        disabled = _this$props.disabled,
        explanation = _this$props.explanation,
        inputRef = _this$props.inputRef,
        inputRight = _this$props.inputRight,
        label = _this$props.label,
        groupId = _this$props.groupId,
        onChange = _this$props.onChange,
        size = _this$props.size,
        value = _this$props.value;
      var id = this.state.id;
      var classes = classnames(className, "c-els-field", "c-els-field--radio", {
        "c-els-field--small": size === Sizes.SMALL,
        "c-els-field--large": size === Sizes.LARGE,
        "c-els-field--x-large": size === Sizes.XLARGE,
        "c-els-field--input-right": inputRight
      });
      return /* @__PURE__ */React.createElement("div", {
        className: classes
      }, /* @__PURE__ */React.createElement("label", {
        className: "c-els-field__label",
        htmlFor: id
      }, /* @__PURE__ */React.createElement("input", {
        checked: checked,
        className: "c-els-field__input",
        "data-testid": "radio-button",
        disabled: disabled,
        id: id,
        name: groupId,
        onChange: onChange,
        type: "radio",
        value: value,
        "aria-describedby": explanation ? "".concat(id, "-explanation") : null,
        ref: inputRef
      }), /* @__PURE__ */React.createElement("span", {
        className: "c-els-field__label-text"
      }, /* @__PURE__ */React.createElement("span", {
        className: "c-els-field__switch"
      }), label)), explanation && /* @__PURE__ */React.createElement("div", {
        className: "u-els-margin-top-1o2",
        id: "".concat(id, "-explanation"),
        "data-testid": "radio-button-explanation"
      }, explanation));
    }
  }]);
}(PureComponent);
RadioButton.displayName = "RadioButton";
RadioButton.Sizes = Sizes;
RadioButton.propTypes = {
  /** Is this radio button selected */
  checked: bool$1,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$1,
  /** Should the radio button be disabled */
  disabled: bool$1,
  /** An optional paragraph explaining the purpose of the radio */
  explanation: string$1,
  /** Group name of RadioButtons */
  groupId: string$1,
  /** Unique identifier for the input field */
  id: string$1,
  /** A React ref applied to the input element */
  inputRef: object$1,
  /** The checkbox should display on the right of the label */
  inputRight: bool$1,
  /** What to render as the label */
  label: string$1,
  /** Size of the field */
  size: oneOf$1(Sizes.getAll()),
  /** The actual value */
  value: string$1,
  /**
   * Custom change callback, passed by RadioButtonGroup
   * @param {React.SyntheticEvent} e the onChange synthetic event from React
   */
  onChange: func$1
};
RadioButton.defaultProps = {
  checked: void 0,
  className: "",
  disabled: false,
  explanation: null,
  groupId: "",
  inputRef: null,
  inputRight: false,
  id: null,
  onChange: null,
  label: "",
  size: Sizes.DEFAULT,
  value: ""
};
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  node = PT.node,
  object = PT.object,
  oneOf = PT.oneOf,
  oneOfType = PT.oneOfType,
  shape = PT.shape,
  string = PT.string;
var RadioButtonGroup = /*#__PURE__*/function (_PureComponent2) {
  function RadioButtonGroup() {
    var _this2$props$options;
    var _this2;
    _classCallCheck(this, RadioButtonGroup);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, RadioButtonGroup, [].concat(args));
    _defineProperty(_this2, "state", {
      // This is misleadingly named, it is used for the radio button `name`
      groupId: generateId(),
      /* eslint-disable react/destructuring-assignment */
      selectedOption: _this2.props.shouldBeSelectedByDefault ? _this2.props.value || ((_this2$props$options = _this2.props.options) === null || _this2$props$options === void 0 ? void 0 : _this2$props$options[0]) : void 0
      /* eslint-enable react/destructuring-assignment */
    });
    _defineProperty(_this2, "getChildren", function () {
      var _this2$props = _this2.props,
        children = _this2$props.children,
        size = _this2$props.size,
        value = _this2$props.value;
      var _this2$state = _this2.state,
        groupId = _this2$state.groupId,
        selectedOption = _this2$state.selectedOption;
      return React.Children.map(children, function (child, index) {
        var _child$props;
        if (!child) {
          return null;
        }
        var selectedValueToUse = value || selectedOption;
        var checked = (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.checked) || _this2.getIsChecked(child.props.value, selectedValueToUse, index);
        return React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          checked: checked,
          className: "".concat(child.props.className, " c-els-field__radio-button-group-option"),
          groupId: groupId,
          onChange: _this2.handleChange,
          size: size
        }));
      });
    });
    _defineProperty(_this2, "getIsChecked", function (fieldValue, propValue, index) {
      var shouldBeSelectedByDefault = _this2.props.shouldBeSelectedByDefault;
      var defaultValue = shouldBeSelectedByDefault ? propValue === void 0 && index === 0 : false;
      var isEqualToValue = propValue === void 0 ? false : fieldValue === propValue;
      return isEqualToValue || defaultValue;
    });
    _defineProperty(_this2, "getOptions", function () {
      var _this2$props2 = _this2.props,
        options = _this2$props2.options,
        size = _this2$props2.size,
        value = _this2$props2.value;
      var _this2$state2 = _this2.state,
        groupId = _this2$state2.groupId,
        selectedOption = _this2$state2.selectedOption;
      return options.map(function (option, index) {
        var optionValue = (option === null || option === void 0 ? void 0 : option.value) || option;
        var optionLabel = (option === null || option === void 0 ? void 0 : option.label) || optionValue;
        var valueToUse = (value === null || value === void 0 ? void 0 : value.value) || value;
        var selectedOptionToUse = valueToUse || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || selectedOption;
        var checked = _this2.getIsChecked(optionValue, selectedOptionToUse, index);
        return /* @__PURE__ */React.createElement(RadioButton, {
          checked: checked,
          className: "c-els-field__radio-button-group-option",
          groupId: groupId,
          key: optionValue,
          label: optionLabel,
          onChange: _this2.handleChange,
          size: size,
          value: optionValue
        });
      });
    });
    _defineProperty(_this2, "handleChange", function (e) {
      var onChange = _this2.props.onChange;
      onChange(e);
      _this2.setState({
        selectedOption: e.target.value
      });
    });
    return _this2;
  }
  _inherits(RadioButtonGroup, _PureComponent2);
  return _createClass(RadioButtonGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        options = _this$props2.options;
      if (React.Children.count(children) && options.length) {
        throw new TypeError("RadioButtonGroup can only take children or options, not both.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        name = _this$props3.a11y.name,
        children = _this$props3.children,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        id = _this$props3.id,
        isInline = _this$props3.isInline,
        messages = _this$props3.messages,
        required = _this$props3.required,
        shouldHideLabel = _this$props3.shouldHideLabel;
      var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
      var classes = classnames(className, "c-els-field__radio-button-group", {
        "c-els-field__radio-button-group--inline": isInline
      });
      var hasChildren = !!React.Children.count(children);
      return /* @__PURE__ */React.createElement("fieldset", {
        className: classes,
        disabled: disabled,
        id: id,
        "data-testid": "radio-button-group"
      }, /* @__PURE__ */React.createElement("legend", {
        className: "c-els-field__legend ".concat(shouldHideLabel ? "u-els-hide-visually" : "")
      }, required && /* @__PURE__ */React.createElement("span", {
        className: "c-els-field__label-required-indicator"
      }, "*", /* @__PURE__ */React.createElement("span", {
        className: "u-els-hide-visually"
      }, "(", compiledMessages.REQUIRED, ")")), name), hasChildren ? this.getChildren() : this.getOptions());
    }
  }]);
}(PureComponent);
RadioButtonGroup.displayName = "RadioButtonGroup";
RadioButtonGroup.propTypes = {
  /** Contains accessibility relevant properties
   *  @property {String} a11y.name Name for the fieldset's legend
   */
  a11y: shape({
    name: string.isRequired
  }).isRequired,
  /** Radio buttons to render
   *
   * Either children OR options should be passed, not both. */
  children: node,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Should the radio button group be disabled */
  disabled: bool,
  /** Unique identifier for the input field; if not provided, one will be generated */
  id: string,
  /** Should render radio buttons in a horizontal layout instead of vertical */
  isInline: bool,
  /** Messages for internationalization */
  messages: object,
  /** The list of options. It must be either an array of strings or an array of objects of the following shape:
   *  @property {String} options.label Visible label for the RadioButton
   *  @property {String} options.value Actual value for the RadioButton
   *
   *  Either children OR options should be passed, not both.
   */
  options: arrayOf(oneOfType([shape({
    label: string,
    value: string.isRequired
  }), string])),
  /** Show a 'required' asterisk and associated hidden descriptive text */
  required: bool,
  /** Should the fieldset have a default selection */
  shouldBeSelectedByDefault: bool,
  /** Should the group label be hidden */
  shouldHideLabel: bool,
  /** Size of the field */
  size: oneOf(RadioButton.Sizes.getAll()),
  /** Currently selected value */
  value: string,
  /**
   * Custom change callback
   * @param {React.SyntheticEvent} e the onChange synthetic event from React
   */
  onChange: func.isRequired
};
RadioButtonGroup.defaultProps = {
  children: null,
  className: "",
  disabled: false,
  id: null,
  isInline: false,
  messages: DefaultMessages,
  options: [],
  required: false,
  shouldHideLabel: false,
  shouldBeSelectedByDefault: true,
  size: RadioButton.Sizes.DEFAULT,
  value: void 0
  // lets this be controlled or uncontrolled
};
RadioButtonGroup.requiredProps = {
  a11y: {
    name: ValidPropTypes.STRING
  },
  onChange: ValidPropTypes.FUNCTION
};
RadioButtonGroup.Option = RadioButton;
RadioButtonGroup.DefaultMessages = DefaultMessages;
var RawRadioButtonGroup = RadioButtonGroup;
var RadioButtonGroup$1 = makeErrorBoundComponent(RawRadioButtonGroup);
export { RadioButtonGroup$1 as RadioButtonGroup, RawRadioButtonGroup };
